import { useParams } from 'react-router'
import { useLocation } from 'react-router-dom'

export const useModuleIds = () => {
  const { accountId, projectId, recordId, ...params } = useParams()
  const location = useLocation()

  const moduleName = location.pathname.includes('/delivery')
    ? 'delivery'
    : 'waste'
  return {
    accountId,
    projectId,
    moduleName,
    recordId,
    ...params
  }
}
